export default function XML_HOME() {
  return (
    <div>
      <h1>XML_HOME</h1>
      <p>This is the XML_HOME component.</p>
    </div>
  );
}